import { defineStore } from "pinia";

const STORAGE_KEY = "yandle_theme";

export const useThemeStore = defineStore("theme", {
  state: () => ({
    mode: readStoredTheme(),
  }),

  getters: {
    isDark: (state) => state.mode === "dark",
  },

  actions: {
    init() {
      this.applyTheme();
    },

    toggle() {
      this.mode = this.mode === "light" ? "dark" : "light";
      localStorage.setItem(STORAGE_KEY, this.mode);
      this.applyTheme();
    },

    setTheme(mode) {
      if (mode !== "light" && mode !== "dark") return;
      this.mode = mode;
      localStorage.setItem(STORAGE_KEY, this.mode);
      this.applyTheme();
    },

    applyTheme() {
      if (typeof document === "undefined") return;
      document.documentElement.setAttribute("data-theme", this.mode);
    },
  },
});

function readStoredTheme() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "light" || stored === "dark") return stored;
  if (typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  return "light";
}
